export default __webpack_public_path__ + "static/media/toe_jump_thumb.a51621b6.png";